/** D2 — verbatim 10 items (05-architecture.md §2.3 / db/schema.md §4.2). */
export const DOCUMENT_TYPES = [
  'personal_photos',
  'birth_certificate',
  'father_id_copy',
  'mother_id_copy',
  'grade9_prep3_success',
  'grade10_sec1_success',
  'grade11_sec2_success',
  'grade12_sec3_success',
  'academic_transcripts',
  'academic_power_of_attorney',
] as const;
export type DocumentType = (typeof DOCUMENT_TYPES)[number];

export const DOCUMENT_RECEIVED_STATUSES = [
  'Not Received',
  'Received',
  'Received — Needs Correction',
] as const;
export type DocumentReceivedStatus = (typeof DOCUMENT_RECEIVED_STATUSES)[number];
